// Marca Orion v2 (kit oficial en CDN; los SVG no se modifican).
// Fuente: /root/agents/orion/brand/v2/README.md — tipografía Sora ya en contornos.
const CDN = 'https://brainstream.b-cdn.net/company_logos/orion/brand/v2';

export const ORION_BRAND = {
  /** horizontal con «Organizational Intelligence», para fondo oscuro (barra lateral) */
  logoDark: `${CDN}/orion-logo-dark.svg`,
  /** símbolo + «Orion», para fondo oscuro */
  logoCompactDark: `${CDN}/orion-logo-compact-dark.svg`,
  /** variantes para fondo claro */
  logoLight: `${CDN}/orion-logo-light.svg`,
  logoCompactLight: `${CDN}/orion-logo-compact-light.svg`,
  /** isotipo (ícono compacto y avatar del asistente) */
  symbol: `${CDN}/orion-symbol.svg`,
  favicon: `${CDN}/orion-favicon.svg`,
} as const;

const isUrl = (v: unknown): v is string => typeof v === 'string' && /^https:\/\//.test(v);
/** Ícono servido por el propio dashboard (mismo origen: sin CORS al dibujarlo). */
const isLocalIcon = (v: unknown): v is string => typeof v === 'string' && /^\/icons\/[\w./-]+\.(png|webp)$/.test(v) && !v.includes('..');

/** Marca efectiva del shell: la de la org si la configura (dashboard.brand), si no la de Orion. */
/** Textos del chat por defecto (producto Orion). Una org/arquetipo los cambia con `dashboard.assistant`. */
export const DEFAULT_ASSISTANT_SUBTITLE = 'Pregúntame por tus leads, tu sitio o cómo crear un agente.';

export function shellBrand(cfg?: { brand?: Record<string, unknown>; assistant?: { suggestions?: unknown; subtitle?: unknown } } | null) {
  const b = (cfg?.brand ?? {}) as Record<string, unknown>;
  const sug = Array.isArray(cfg?.assistant?.suggestions)
    ? (cfg!.assistant!.suggestions as unknown[]).filter((x): x is string => typeof x === 'string' && !!x.trim()).slice(0, 6)
    : [];
  const sub = typeof cfg?.assistant?.subtitle === 'string' && cfg.assistant.subtitle.trim() ? cfg.assistant.subtitle.trim() : null;
  const name = typeof b.name === 'string' && b.name.trim() ? b.name.trim() : 'Orion · Organizational Intelligence';
  const assistant = typeof b.assistant_name === 'string' && b.assistant_name.trim() ? b.assistant_name.trim() : 'Orion';
  return {
    logoDark: isUrl(b.logo_dark) ? b.logo_dark : ORION_BRAND.logoDark,
    symbol: isUrl(b.symbol) ? b.symbol : ORION_BRAND.symbol,
    favicon: isUrl(b.favicon) ? b.favicon : ORION_BRAND.favicon,
    /** Avatar del agente flotante (opt-in, `dashboard.brand.agent_avatar`). null →
     *  el orbe de Orion y el título «Agente», como siempre. Es independiente de
     *  `symbol` para no cambiar el agente de orgs que ya tienen isotipo. */
    agentAvatar: isUrl(b.agent_avatar) ? b.agent_avatar : null,
    name,
    assistantName: assistant,
    /** App instalable (PWA): ícono cuadrado y nombre corto propios (opt-in). null → se
     *  conserva lo de siempre (ícono dibujado desde el logo, nombre recortado). */
    appIcon: isUrl(b.app_icon) || isLocalIcon(b.app_icon) ? (b.app_icon as string) : null,
    appShortName: typeof b.app_short_name === 'string' && b.app_short_name.trim() ? b.app_short_name.trim().slice(0, 30) : null,
    custom: isUrl(b.logo_dark),
    /** null → el llamador usa sus sugerencias de siempre. */
    suggestions: sug.length ? sug : null,
    subtitle: sub ?? DEFAULT_ASSISTANT_SUBTITLE,
  };
}
